module.exports = __webpack_public_path__ + "img/5.c81a90c4.png";